export default { sha: '8a83e3942891e9b2123e76bb7fa68b600a53bd80', buildNumber: 'undefined' }
